"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterChannel = void 0;
const topic_1 = require("../../topic");
const ROUTER_CHANNEL = "router";
class RouterChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = ROUTER_CHANNEL;
        this.topics = {
            Navigate: new topic_1.Topic('Navigate', ROUTER_CHANNEL, this._logger),
            NavigateV2: new topic_1.Topic('NavigateV2', ROUTER_CHANNEL, this._logger),
            NavigateByCode: new topic_1.Topic('NavigateByCode', ROUTER_CHANNEL, this._logger),
        };
    }
}
exports.RouterChannel = RouterChannel;
//# sourceMappingURL=router.channel.js.map